import { DataTypeForES } from '@ariksa/reporting';

export const exportAlertsTypeOptions = [
  { label: 'Inventory', value: DataTypeForES.Resources },
  { label: 'Alerts', value: DataTypeForES.Alerts },
  { label: 'Vulnerabilities', value: DataTypeForES.Vulnerabilities },
];

export const exportAlertsTargetOptions = [{ label: 'SIEM', value: 'SIEM' }];
